module.exports = __webpack_public_path__ + "KabelBdNormal.woff?80ac3c9c533417dbb51e0d360db21e1c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/KabelBdNormal.woff
// module id = 45
// module chunks = 0